export const comments_3324452 = {"data":{"data":[],"links":{}}}